import { useSelector, useDispatch } from 'react-redux';
import { setProfileViewing } from '../../Redux/store';
import CloseButton from '../../components/CloseButton';
import ProfileRow from '../../components/ProfileRow';
import ModalWrapper from '../../components/ModalWrapper';
import ProfileFull from './ProfileFull';
import useProfileData from '../../hooks/useProfileData';

// Modal wrapper for profile viewing
function ProfileFullMenu() {
  const dispatch = useDispatch();
  // Get viewing state from Redux
  const profileViewing = useSelector((s) => s.ui.profileViewing);
  // Fetch profile data
  const { profile } = useProfileData(profileViewing?.id);

  // If no profile is being viewed don't render
  if (!profileViewing) return null;

  // Close by clearing profileViewing in Redux
  const close = () => dispatch(setProfileViewing(null));

  return (
    <ModalWrapper onClose={close}>
      {/* Header with profile and close - always at top */}
      <div className="shrink-0 px-5 py-2 flex items-center justify-between border-b border-border">
        <ProfileRow profile={profile} size="md" />
        <CloseButton onClose={close} />
      </div>

      {/* Content component - fills remaining space */}
      <div className="flex-1 min-h-0">
        <ProfileFull id={profileViewing.id} initialTab={profileViewing.tab} />
      </div>
    </ModalWrapper>
  );
}

export default ProfileFullMenu;